import React, {lazy} from 'react';

import { RepairWay } from './common/constant';
import SafePhoneRepair from './pages/PC/SafePhoneRepair';

const DataReview = lazy(() => import('./pages/PC/DataReview'));
const MethodList = lazy(() => import('./pages/PC/MethodList'));
const LowValueAccountWay = lazy(() => import('./pages/PC/LowValueAccountWay'));
const Result = lazy(() => import('./pages/common/Result'))
const SafePhoneBind = lazy(() => import('./pages/common/SafePhoneBind'));
const Inquire = lazy(() => import('./pages/common/Inquire'));
const InquireResult = lazy(() => import('./pages/common/InquireResult'));
const TaskPublicity = lazy(() => import('./pages/PC/TaskPublicity'));
const AnnouncementPage = lazy(() => import('./pages/common/Announcement'));
const AddressVerifyResult = lazy(() => import('./pages/common/AddressVerifyResult'));
const AddressVerify = lazy(() => import('./pages/common/AddressVerify'));
const ExplainGuide = lazy(() => import('./pages/common/ExplainGuide'));
const PreventFix = lazy(() => import('./pages/PC/PreventFix'));
const SesameCreditAuth = lazy(() => import('./pages/common/SesameCreditAuth'));
const ExternalPlatformAuth = lazy(() => import('./pages/common/ExternalPlatformAuth'));
const ExternalPlatformSelect = lazy(() => import('./pages/common/ExternalPlatformSelect'));
const DelaySubmitPage = lazy(() => import('./pages/common/DelaySubmitPage'));

export const routes = [
    {
        component: <MethodList />,
        path: '/',
        exact: true,
        withStatus: true,
        withAccount: true,
        withMainLayout: true
    }, {
        component: <DataReview />,
        path: '/dataReview',
        exact: true,
        withStatus: true,
        withAccount: true,
        withMainLayout: true
    },{
        component: <Result />,
        path: '/result',
        exact: true,
        withAccount: true,
        withMainLayout: true
    },{
        component: <Inquire />,
        path: '/inquire',
        exact: true,
        withAccount: true,
        withStatus: true,
        withMainLayout: true
    },{
        component: <InquireResult />,
        path: '/inquireResult',
        exact: true,
        withMainLayout: true,
        withAccount: true,
    },{
        component: <SafePhoneBind />,
        path: '/safePhoneBind',
        exact: true,
        withAccount: true,
        withMainLayout: true
    },{
        component: <LowValueAccountWay repairWay={RepairWay.lowValueBankCard} />,
        path: '/bankCardReview',
        exact: true,
        withAccount: true,
        withStatus: true,
        withMainLayout: true
    },{
        component: <LowValueAccountWay repairWay={RepairWay.lowValueExplainBankCard} />,
        path: '/bankCardExplain',
        exact: true,
        withAccount: true,
        withMainLayout: true
    },{
        component: <LowValueAccountWay repairWay={RepairWay.lowValueHoldingIDCard} />,
        path: '/holdingIDCardReview',
        exact: true,
        withAccount: true,
        withStatus: true,
        withMainLayout: true
    },{
        component: <LowValueAccountWay repairWay={RepairWay.lowValueExplainHoldingIDCard} />,
        path: '/holdingIDCardExplain',
        exact: true,
        withAccount: true,
        withMainLayout: true
    },{
        component: <TaskPublicity />,
        path: '/taskPublicity',
        exact: true,
    },{
        component: <AnnouncementPage />,
        path: '/announcementPage',
        exact: true,
        withPhone: true,
    },{
        component: <AddressVerifyResult />,
        path: '/addressVerifyResult',
        exact: true,
        withMainLayout: true,
    },{
        component: <AddressVerify />,
        path: '/addressVerify',
        exact: true,
        withMainLayout: true,
    },{
        component: <ExplainGuide />,
        path: '/explainGuide',
        exact: true,
        withMainLayout: true,
    },{
        component: <PreventFix />,
        path: '/preventFix',
        exact: true,
        withMainLayout: true,
    },{
        component: <SafePhoneRepair />,
        path: '/safePhoneRepair',
        exact: true,
        withStatus: true,
        withAccount: true,
        withMainLayout: true,
        withPhone: true,
    },{
        component: <SesameCreditAuth />,
        path: '/sesameCreditAuth',
        exact: true,
        withAccount: true,
        withPhone: true,
        withMainLayout: true,
    },
    {
        component: <ExternalPlatformAuth />,
        path: '/platformAuth',
        exact: true,
        withAccount: true,
        withPhone: true,
        withMainLayout: true,
    },
    {
        component: <ExternalPlatformSelect />,
        path: '/platformSelect',
        exact: true,
        withAccount: true,
        withPhone: true,
        withMainLayout: true,
    },
    {
        component: <DelaySubmitPage />,
        path: '/delaySubmit',
        exact: true,
        withAccount: true,
        withPhone: true,
        withMainLayout: true,
    },
]